/* Pila con títulos visibles y apertura por nombre. Sticky y animaciones son
   CSS; aquí solo se miden etiquetas y se atienden clics/cambios de geometría. */
(function () {
  'use strict';
  var grupos = [], frame = 0;
  var movil = window.matchMedia('(max-width: 900px)');
  function montar(root, section, head, kind) {
    if (!root || !section || !head) return;
    var cards = Array.from(root.children).filter(function (el) { return el.matches('.hab-tipo, .itin-card'); });
    var g = { root: root, section: section, head: head, cards: cards, kind: kind, selected: null };
    root.classList.add('stack-ready');
    cards.forEach(function (card, i) {
      if (kind === 'rooms') {
        var block = document.createElement('div'); block.className = 'hab-tipo-block';
        while (card.firstChild) block.appendChild(card.firstChild);
        card.appendChild(block);
      }
      var name = card.querySelector(kind === 'rooms' ? '.hab-tipo-name' : '.itin-name');
      var title;
      if (kind === 'rooms') title = card.querySelector('.hab-tipo-title');
      else {
        title = document.createElement('header'); title.className = 'itin-card-title';
        title.appendChild(name); card.insertBefore(title, card.firstChild);
      }
      var btn = document.createElement('button');
      btn.type = 'button'; btn.className = 'stack-toggle'; btn.setAttribute('data-sin-trazo', '');
      var text = document.createElement('span'); text.textContent = name.textContent;
      if (name.hasAttribute('data-i18n')) {
        text.setAttribute('data-i18n', name.getAttribute('data-i18n')); name.removeAttribute('data-i18n');
      }
      btn.appendChild(text); name.replaceChildren(btn);
      var panels = Array.from(card.querySelectorAll(kind === 'rooms' ? '.hab-tipo-details, .hab-unidades' : '.itin-card-in'));
      panels.forEach(function (panel, n) {
        panel.classList.add('stack-panel'); panel.id = 'stack-' + kind + '-' + i + '-' + n;
      });
      btn.setAttribute('aria-controls', panels.map(function (p) { return p.id; }).join(' '));
      btn.setAttribute('aria-expanded', 'true');
      card.classList.add('stack-card'); card._stack = { title: title, btn: btn, panels: panels };
      btn.addEventListener('click', function (event) { abrir(g, card, event); });
    });
    if (kind === 'tours') {
      var reset = document.createElement('button'); reset.type = 'button'; reset.className = 'stack-reset';
      reset.hidden = true; reset.setAttribute('data-i18n', 'stack.showAll');
      reset.textContent = window.I18N ? window.I18N.t('stack.showAll') : 'Ver todos';
      reset.addEventListener('click', function () { restaurar(g); medir(); ir(g, cards[0]); });
      head.appendChild(reset); g.reset = reset;
    }
    grupos.push(g);
  }
  function restaurar(g) {
    g.selected = null; g.root.classList.remove('stack-focused');
    if (g.reset) g.reset.hidden = true;
    g.cards.forEach(function (card) {
      card.classList.remove('is-selected');
      card._stack.panels.forEach(function (p) { p.hidden = false; });
      card._stack.btn.setAttribute('aria-expanded', 'true');
    });
  }
  function abrir(g, card, event) {
    var changed = g.selected !== card;
    g.selected = card; g.root.classList.add('stack-focused');
    if (g.reset) g.reset.hidden = false;
    g.cards.forEach(function (c) {
      c.classList.toggle('is-selected', c === card);
      c._stack.panels.forEach(function (p) { p.hidden = c !== card; });
      c._stack.btn.setAttribute('aria-expanded', c === card ? 'true' : 'false');
    });
    medir(); ir(g, card);
    if (changed && window.HotelMotion) {
      var pieces = card.querySelectorAll(g.kind === 'rooms' ? '.hab-tipo-details, .hab-unidades > *' : '.itin-card-media, .itin-card-text');
      window.HotelMotion.enter(pieces, event, { duration: 240, stagger: 30 });
    }
    card._stack.btn.focus({ preventScroll: true });
    window.dispatchEvent(new Event('resize'));
  }
  function ir(g, card) {
    if (!card) return;
    // Medir en flujo: offsetTop de un sticky ya fijado incluye su desfase.
    // Es una medición puntual al pulsar, nunca durante el scroll.
    var position = card.style.position, top = card.style.top;
    card.style.position = 'relative'; card.style.top = 'auto';
    var y = 0, el = card;
    while (el) { y += el.offsetTop; el = el.offsetParent; }
    card.style.position = position; card.style.top = top;
    window.scrollTo({ top: Math.max(0, y - card._stack.top), behavior: 'instant' });
  }
  function medir() {
    frame = 0;
    var nav = document.getElementById('nav');
    grupos.forEach(function (g) {
      if (!g.head.offsetHeight) return;
      // Solo se descuenta el encabezado si está anclado (ver subheaders.js).
      var fijo = getComputedStyle(g.head).position === 'sticky';
      var base = (nav ? nav.offsetHeight : 0) + (fijo ? g.head.offsetHeight : 0) + 16;
      if (g.kind === 'rooms') {
        // Misma pila progresiva de títulos que Experiencias. Suite se fija
        // pegada al borde inferior del menú de habitaciones (sin hueco) y cada
        // tipo se apila justo debajo del anterior.
        base = (nav ? nav.offsetHeight : 0) + (fijo ? g.head.offsetHeight : 0);
        g.root.style.setProperty('--stack-title-top', base + 'px');
      }
      var visible = g.cards.filter(function (c) { return !c.hidden; }), offset = 0, footprint = 0;
      // Todas las tarjetas terminan en la misma línea al quedar fijadas.
      // Así se sueltan juntas al final, sin subir un cuerpo sobre otro título.
      visible.forEach(function (card) { card.style.removeProperty('--stack-height'); });
      visible.forEach(function (card, i) {
        var top = g.selected && card === g.selected ? base : base + offset;
        card._stack.top = top;
        card._stack.offset = offset;
        card.style.setProperty('--stack-top', top + 'px');
        card.style.setProperty('--stack-order', i + 1);
        card.style.setProperty('--stack-count', visible.length);
        footprint = Math.max(footprint, offset + card.offsetHeight);
        offset += Math.ceil(card._stack.title.getBoundingClientRect().height);
      });
      var bottom = document.querySelector('.frame-bottom');
      var room = window.innerHeight - (bottom ? bottom.offsetHeight : 0);
      // Ambos catálogos conservan sus títulos aunque el último cuerpo
      // continúe bajo el marco: pulsarlo lo abre entero en el flujo normal.
      var reserva = 16;
      // Móvil (2026-10-20, decisión del usuario): si los títulos apilados
      // tapan más del 35 % del área visible, la pila pasa al flujo normal.
      // Los siete títulos miden ~370 px: en un teléfono en vertical eran del
      // 48 al 79 % de la pantalla. El escritorio conserva la pila.
      var util = room - (nav ? nav.offsetHeight : 0);
      var scroll = base + offset + reserva > room || (movil.matches && offset > util * 0.35);
      g.root.classList.toggle('stack-scroll', scroll);
      visible.forEach(function (card) {
        if (!g.selected && !scroll) card.style.setProperty('--stack-height', (footprint - card._stack.offset) + 'px');
      });
      g.root.style.setProperty('--stack-tail', g.selected || scroll ? '0px' : offset + 'px');
    });
  }
  function programar() { if (!frame) frame = requestAnimationFrame(medir); }
  // Habitaciones ya no usa la pila: sus tipos van uno tras otro, sin efecto (2026-10-12).
  // La pila de tours de Experiencias pasó a ser «recuerdos» (recuerdos.js).
  if (!document.querySelector('.itin--recuerdos')) montar(document.querySelector('.itin-stack'), document.querySelector('.itin'), document.querySelector('.itin-head'), 'tours');
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hab-filtro')) return;
    grupos.filter(function (g) { return g.kind === 'rooms'; }).forEach(restaurar);
    medir(); programar();
  }, true);
  if (window.ResizeObserver) {
    var sizes = new ResizeObserver(programar);
    grupos.forEach(function (g) { sizes.observe(g.head); g.cards.forEach(function (c) {
      sizes.observe(c._stack.title); c._stack.panels.forEach(function (p) { sizes.observe(p); });
    }); });
  }
  var changes = new MutationObserver(programar);
  document.querySelectorAll('.page, .hab-tipo').forEach(function (el) { changes.observe(el, { attributes: true, attributeFilter: ['hidden'] }); });
  window.addEventListener('resize', programar);
  document.addEventListener('i18n:change', programar);
  if (document.fonts) document.fonts.ready.then(programar);
  programar();
})();
